function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3 7.5V5.25A2.25 2.25 0 015.25 3H7.5M3 16.5v2.25A2.25 2.25 0 005.25 21H7.5M21 16.5v2.25A2.25 2.25 0 0118.75 21H16.5M21 7.5V5.25A2.25 2.25 0 0018.75 3H16.5M5.25 12h13.5M7.5 7.5h9v9h-9v-9z",
  stroke: "#4D4D4D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgScan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default __webpack_public_path__ + "/img/scan.svg";
export { SvgScan as ReactComponent };